import useApi from "./useApi";

const useBankAccount = () => {
    const { getJson, postJson } = useApi();

    /**
     * Fetches the supported bank account types from the API.
     * @returns {Promise<string[]>}
     */
    const getSupportedBankTypes = async () => {
        const response = await getJson('/online/bankaccounttypes');
        return (response.overpaidbankaccount ?? []).map(item => item.type);
    }

    /**
     * Posts a new bank account to the API.
     * @param data
     * @returns {Promise<*>}
     */
    const postBankAccount = async (data) => {
        return await postJson('/online/bankaccount', data);
    }

    /**
     * Validates a bank account number based on its type.
     * @param {string|null|undefined} accountNumberType
     * @param {string|null|undefined} accountNumber
     * @returns {Promise<{
     *   is_valid: boolean, bic: string|null, account_number: string, account_number_type: string
     * }|null>}
     */
    const validateBankAccount = async (accountNumberType, accountNumber) => {
        if (!['iban', 'bban'].includes(accountNumberType) ||
            accountNumber === undefined ||
            accountNumber === null ||
            accountNumber.trim() === '') {
            return null;
        }
        return await postJson(
            '/online/bankaccount/validate',
            { account_number: accountNumber, account_number_type: accountNumberType }
        );
    }

    return {
        getSupportedBankTypes,
        postBankAccount,
        validateBankAccount
    }
}

export default useBankAccount;
